import { createContext, useContext } from 'react';

import { type AnalyticsFilter } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

/** The cohort filter every card on the page is drawn from, plus its readable summary. */
export type AnalyticsFilterContextValue = Readonly<{
  filter: AnalyticsFilter;
  summary: readonly string[];
}>;

const AnalyticsFilterContext = createContext<AnalyticsFilterContextValue>({
  filter: {},
  summary: [],
});

export const AnalyticsFilterProvider = AnalyticsFilterContext.Provider;

export const useAnalyticsFilter = () => useContext(AnalyticsFilterContext);
